import type { FetchPageServiceParameters } from "~/core/composables/useFetchPage";
import type { PaginatedList } from "~/core/models/PaginatedList.interface";
import type { FiltersSelection } from "~/core/models/filters";
import RestService from "~/core/services/rest.service";
import type { CampaignOperationMgr } from "~/modules/campaign/models/CampaignOperationMgr.interface";
import type { CampaignOperationMgrCreate } from "~/modules/campaign/models/CampaignOperationMgrCreate.interface";
import type { CampaignOperationMgrUpdate } from "~/modules/campaign/models/CampaignOperationMgrUpdate.interface";
import organizationService from "~/modules/organization/services/organization.service";

export class CampaignOperationMgrService extends RestService {
  async findWithPagination({
    organizationCode,
    page,
    pageSize,
    sort,
    searchParams,
  }: FetchPageServiceParameters): Promise<PaginatedList<CampaignOperationMgr>> {
    const params = { page, pageSize, filter: searchParams, sort };
    return this.$apiV2.get(
      this.getOrganizationCampaignsPath(organizationCode),
      {
        params,
      },
    );
  }

  async find(
    uid: string,
    organizationCode?: number,
    searchParams?: string | FiltersSelection,
  ): Promise<CampaignOperationMgr> {
    const params = { filter: searchParams };
    return this.$apiV2.get(
      `${this.getOrganizationCampaignsPath(organizationCode)}/${uid}`,
      { params },
    );
  }

  async create(
    campaign: CampaignOperationMgrCreate,
    organizationCode?: number,
  ): Promise<CampaignOperationMgr> {
    return this.$apiV2.post(
      this.getOrganizationCampaignsPath(organizationCode),
      campaign,
    );
  }

  async update(
    uid: string,
    campaign: CampaignOperationMgrUpdate,
    organizationCode?: number,
  ) {
    return this.$apiV2.patch(
      `${this.getOrganizationCampaignsPath(organizationCode)}/${uid}`,
      campaign,
    );
  }

  async cancel(
    uid: string,
    organizationCode?: number,
  ): Promise<CampaignOperationMgr> {
    return this.$apiV2.post(
      `${this.getOrganizationCampaignsPath(organizationCode)}/${uid}/cancel`,
    );
  }

  private getOrganizationCampaignsPath(organizationCode: number | undefined) {
    return `${organizationService.getOrganizationPath(organizationCode)}/campaigns`;
  }
}
export default new CampaignOperationMgrService();
